export default function (...args: any[]) {
    var ret: string = "";
    //The last argument will be always the options of function
    for (var i = 0; i < args.length - 1; i++) {
        ret += args[i];
    }
    return ret;
}
